import E from 'tiny-emitter/instance';

export default E;

export function on (map) {
  return {
    mounted () {
      Object.entries(map).forEach(([e, cb]) =>
        E.on(e, typeof cb === 'string' ? this[cb] : cb)
      );
    },

    unmounted () {
      Object.entries(map).forEach(([e, cb]) =>
        E.off(e, typeof cb === 'string' ? this[cb] : cb)
      );
    },
  }
}